var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main",staticClass:"main"},[_c('div',{staticClass:"left"},[_c('left')],1),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"rightTop"},[_c('main-header')],1),_vm._v(" "),_c('div',{ref:"rightBottom",staticClass:"rightBottom"},[_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cefc88aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = null
// module chunks = 